module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "min-height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_c('div', {
    staticClass: "customer-left-bg",
    style: (_vm.login_cm_bj)
  }, [_c('div', {
    staticClass: "login-opactiy"
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "Systemlogin-container"
  }, [_c('div', {
    staticClass: "systemLogin"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0 13%"
    }
  }, [_c('div', {
    staticClass: "login-logo-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/MKD-logo2.jpg"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.toOurWeb()
      }
    }
  })]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.forgetPwd),
      expression: "!forgetPwd"
    }],
    ref: "loginForm",
    staticClass: "login-form",
    attrs: {
      "autoComplete": "on",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "title-container"
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "display": "inline-block",
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.gets('$客户端登录')))]), _vm._v(" "), _c('lang-select', {
    staticClass: "set-language right lan"
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "user"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.gets('$登录名称')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "username",
      "type": "text",
      "autoComplete": "on",
      "placeholder": _vm.gets('$请输入登录名')
    },
    model: {
      value: (_vm.loginPage.LoginName.value),
      callback: function($$v) {
        _vm.$set(_vm.loginPage.LoginName, "value", $$v)
      },
      expression: "loginPage.LoginName.value"
    }
  })], 1), _vm._v("\r\n                        " + _vm._s(_vm.loginPage.LoginName.error) + "\r\n                        "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "svg-container"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "password"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.gets('$密码')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "password",
      "type": "password",
      "autoComplete": "on",
      "placeholder": _vm.gets('$请输入密码')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      }
    },
    model: {
      value: (_vm.loginPage.Password.value),
      callback: function($$v) {
        _vm.$set(_vm.loginPage.Password, "value", $$v)
      },
      expression: "loginPage.Password.value"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "show-pwd"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "eye"
    }
  })], 1)], 1), _vm._v("\r\n                        " + _vm._s(_vm.loginPage.Password.error) + "\r\n                    \r\n                        \r\n                        "), _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "justify-content": "space-between",
      "margin-top": "10px"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "name": "记住密码"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v(_vm._s(_vm.gets('$记住密码')))]), _vm._v(" "), (_vm.language == 'EN') ? _c('div', {
    staticClass: "forgetPWD",
    on: {
      "click": _vm.findPwd
    }
  }, [_vm._v("Forgotten Password?")]) : _vm._e(), _vm._v(" "), (_vm.language == 'CN') ? _c('div', {
    staticClass: "forgetPWD",
    on: {
      "click": _vm.findPwd
    }
  }, [_vm._v("忘记密码？")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "customer-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.gets('$登录')))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "customer-btn"
  }, [(_vm.language == 'CN') ? _c('div', {
    staticStyle: {
      "height": "15px"
    }
  }, [_vm._v("没有账号？ "), _c('span', {
    staticStyle: {
      "color": "#409EFF",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showRegisterDialog = true
      }
    }
  }, [_vm._v("在此注册")])]) : _c('div', {
    staticStyle: {
      "height": "15px"
    }
  }, [_vm._v("Don't have account？ "), _c('span', {
    staticStyle: {
      "color": "#409EFF",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showRegisterDialog = true
      }
    }
  }, [_vm._v("Sign Up Here")])])])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.forgetPwd),
      expression: "forgetPwd"
    }],
    ref: "loginForm",
    staticClass: "login-form",
    attrs: {
      "autoComplete": "on",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "title-container"
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "display": "inline-block",
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.gets('$找回密码')))]), _vm._v(" "), _c('lang-select', {
    staticClass: "set-language right lan"
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "useremail"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "user"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "useremail",
      "type": "text",
      "autoComplete": "off",
      "placeholder": _vm.gets('$请输入电子邮件地址')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd()
      }
    },
    model: {
      value: (_vm.useremail),
      callback: function($$v) {
        _vm.useremail = $$v
      },
      expression: "useremail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "customer-btn",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.resetPwd()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$下一步')))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "customer-btn"
  }, [(_vm.language == 'CN') ? _c('div', {
    staticStyle: {
      "height": "15px",
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#409EFF",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.ReturnToLogin
    }
  }, [_vm._v("返回登录页")])]) : _c('div', {
    staticStyle: {
      "height": "15px",
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#409EFF",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.ReturnToLogin
    }
  }, [_vm._v("Return")])])])], 1)], 1)])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "Register-dialog-wrapper",
    attrs: {
      "visible": _vm.showRegisterDialog,
      "modal-append-to-body": true,
      "append-to-body": true,
      "width": "30%",
      "title": "Register",
      "min-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showRegisterDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "Register1-dialog"
  }, [_c('div', {
    staticClass: "Register1-dialog-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/MKD-logo2.jpg"),
      "alt": "",
      "width": "330px"
    },
    on: {
      "click": function($event) {
        return _vm.toOurWeb()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Register1-dialog-form1"
  }, [_c('el-form', {
    ref: "registerForm",
    staticClass: "Register1-dialog-form1-input",
    attrs: {
      "autoComplete": "on",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "title-container"
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "color": "#000",
      "font-size": "27px"
    }
  }, [_vm._v(_vm._s(_vm.gets('$注册')))]), _vm._v(" "), _c('lang-select', {
    staticClass: "set-language right lan"
  })], 1), _vm._v(" "), (_vm.FiretForm) ? _c('div', [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "user"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$登录名')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "username",
      "type": "text",
      "autoComplete": "on",
      "placeholder": _vm.gets('$请输入登录名')
    },
    model: {
      value: (_vm.RegisterParam.LoginName),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "LoginName", $$v)
      },
      expression: "RegisterParam.LoginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "svg-container"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "password"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$密码')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "password",
      "type": "password",
      "autoComplete": "on",
      "placeholder": _vm.gets('$请输入密码')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      }
    },
    model: {
      value: (_vm.RegisterParam.Password),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "Password", $$v)
      },
      expression: "RegisterParam.Password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "show-pwd"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "eye"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-right": "20px",
      "width": "50%"
    },
    attrs: {
      "prop": "FirstName"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$姓')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "aria-autocomplete": "off",
      "name": "FirstName",
      "type": "text",
      "autoComplete": "on",
      "placeholder": _vm.gets('$请输入姓')
    },
    model: {
      value: (_vm.RegisterParam.FirstName),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "FirstName", $$v)
      },
      expression: "RegisterParam.FirstName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "prop": "LastName"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$名')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "LastName",
      "type": "text",
      "autoComplete": "on",
      "placeholder": _vm.gets('$请输入名')
    },
    model: {
      value: (_vm.RegisterParam.LastName),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "LastName", $$v)
      },
      expression: "RegisterParam.LastName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "Country"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$国家')))]), _vm._v(" "), _c('el-select', {
    attrs: {
      "popper-append-to-body": false,
      "clearable": "",
      "auto-complete": "",
      "filterable": ""
    },
    model: {
      value: (_vm.RegisterParam.Country),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "Country", $$v)
      },
      expression: "RegisterParam.Country"
    }
  }, _vm._l((_vm.CountryList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "Email"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$邮箱')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "Email",
      "type": "text",
      "autoComplete": "on",
      "placeholder": _vm.gets('$请输入邮箱')
    },
    model: {
      value: (_vm.RegisterParam.Email),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "Email", $$v)
      },
      expression: "RegisterParam.Email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "PhoneNumber"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.gets('$手机')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "PhoneNumber",
      "type": "text",
      "autoComplete": "on",
      "placeholder": _vm.gets('$请输入手机')
    },
    model: {
      value: (_vm.RegisterParam.PhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "PhoneNumber", $$v)
      },
      expression: "RegisterParam.PhoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "Register1-form1-button",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    staticClass: "Register1-form1-button",
    on: {
      "click": function($event) {
        return _vm.verifyForm1()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$下一步')))])], 1)], 1) : _c('div', [_c('el-form-item', {
    attrs: {
      "prop": "contactType"
    }
  }, [_c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$联系软件')))]), _vm._v(" "), _c('el-select', {
    attrs: {
      "popper-append-to-body": false
    },
    model: {
      value: (_vm.RegisterParam.contactType),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "contactType", $$v)
      },
      expression: "RegisterParam.contactType"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "contactID"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "user"
    }
  })], 1), _vm._v(" "), (_vm.RegisterParam.contactType == 1) ? _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v("WeChat ID")]) : (_vm.RegisterParam.contactType == 3) ? _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v("WhatsApp ID")]) : _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v("Contact phone number/method")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "contactID",
      "type": "text",
      "autoComplete": "on",
      "placeholder": _vm.gets('$请输入联系ID')
    },
    model: {
      value: (_vm.RegisterParam.contactID),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "contactID", $$v)
      },
      expression: "RegisterParam.contactID"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "CurrencyID"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$币种')))]), _vm._v(" "), _c('el-select', {
    attrs: {
      "popper-append-to-body": false
    },
    model: {
      value: (_vm.RegisterParam.CurrencyID),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "CurrencyID", $$v)
      },
      expression: "RegisterParam.CurrencyID"
    }
  }, _vm._l((_vm.CurrencyList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "ServiceType"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$服务类型')))]), _vm._v(" "), _c('el-select', {
    attrs: {
      "popper-append-to-body": false
    },
    model: {
      value: (_vm.RegisterParam.ServiceType),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "ServiceType", $$v)
      },
      expression: "RegisterParam.ServiceType"
    }
  }, _vm._l((_vm.ServeLevels), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "CusLevel"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$客户等级')))]), _vm._v(" "), _c('el-select', {
    attrs: {
      "popper-append-to-body": false
    },
    model: {
      value: (_vm.RegisterParam.CusLevel),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "CusLevel", $$v)
      },
      expression: "RegisterParam.CusLevel"
    }
  }, _vm._l((_vm.UserLevels), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "CusLevel"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "red",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.gets('$客户来源')))]), _vm._v(" "), _c('el-select', {
    attrs: {
      "popper-append-to-body": false
    },
    model: {
      value: (_vm.RegisterParam.Source),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "Source", $$v)
      },
      expression: "RegisterParam.Source"
    }
  }, _vm._l((_vm.SourceList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "Remarks"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "user"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.gets('$备注')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "Remarks",
      "type": "text",
      "autoComplete": "on",
      "placeholder": _vm.gets('$请输入备注')
    },
    model: {
      value: (_vm.RegisterParam.Remarks),
      callback: function($$v) {
        _vm.$set(_vm.RegisterParam, "Remarks", $$v)
      },
      expression: "RegisterParam.Remarks"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "Register1-form1-button Register1-form1-button2",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    staticClass: "Register1-form1-button",
    on: {
      "click": function($event) {
        return _vm.aaa()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$注册')))])], 1)], 1)])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "systemTopText"
  }, [_c('div', {
    staticClass: "systemTopText-two"
  }, [_c('img', {
    staticStyle: {
      "width": "38%",
      "margin-right": "2%"
    },
    attrs: {
      "src": require("../assets/img/shipping.png"),
      "alt": ""
    }
  }), _vm._v("has fast \r\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "systemTopText-one"
  }, [_vm._v("\r\n                        warehousing service \r\n                    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "26px",
      "line-height": "2rem",
      "margin-top": "6%"
    }
  }, [_c('div', [_vm._v("\r\n                            Easily find products to sell online\r\n                        ")]), _vm._v(" "), _c('div', [_vm._v("\r\n                            ship them directly to your customers.\r\n                        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "22px",
      "line-height": "2rem",
      "margin-top": "30%",
      "font-weight": "lighter",
      "font-style": "oblique",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/douhao.png"),
      "alt": "",
      "width": "17px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-weight": "lighter"
    }
  }, [_vm._v("\r\n                            It has never been easier to start your own dropshipping\r\n                            "), _c('div', [_vm._v("\r\n                                business with Shipping Revolution. Shipping Revolution\r\n                            ")]), _vm._v(" "), _c('div', [_vm._v("\r\n                                lets you  find products on the world's most popular market-\r\n                            ")]), _vm._v(" "), _c('div', [_vm._v("\r\n                                places,add them to your e-commerce store, and ship them\r\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "end"
    }
  }, [_vm._v("\r\n                                directly to your customers. \r\n                                "), _c('img', {
    attrs: {
      "src": require("../assets/img/douhao2.png"),
      "alt": "",
      "width": "17px"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1e957a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/Customerlogin.vue
// module id = 1296
// module chunks = 169